import React, { useEffect, useState } from "react";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import lywoSymbl from "../assets/images/lywoSymbl.svg";
import LYWOLogo from "../assets/images/LYWOlogo.svg";
import FemaleHr from "../assets/images/FemaleHr.svg";
import "../../src/assets/style/lywocode.css"
import arrowRight from "../assets/images/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import uploadIcon from "../assets/images/UploadIcon.svg";
import VerifiedUser from "../assets/images/VerifiedUserBlue.svg";
import closeIcon from "../assets/images/closeIcon.svg";
import aboutJobIcon from "../assets/images/aboutJobBlue.svg";
import aboutCompanyIcon from "../assets/images/aboutCompnyBlue.svg";
import backtoTopIcon from "../assets/images/backToTopBlue.svg";
import { educationLevel } from "../constant/educationLevel";
import { useSelector } from "react-redux";
import { BASE_URL } from "../api/ApiConfig";
import { isValidEmail } from "../common";
import CustomSelect from "../components/customSlect";
import CustomButton from "../components/customButton";
import { countryCodes } from "../constant/countryCodes";
import { expOptions } from "../constant/exprience";


const InternalAssessmentForm = (props) => {


    const { details,
        setDetails,
        specialization,
        errors,
        handleProceed,
        isApiCalled,
        departments,
        isNotFilledData,
        isRedirect,
        handleUserCreateOnNo,
        handleValidedEmailMsg
    } = props


    const state = useSelector(state => state.roundData)



    const handleInputChange = (e) => {
        let { name, value } = e.target;

        if (name === 'name' && value?.length === 40) {
            return
        }

        if (name === 'email') value = value.trim()
        setDetails(prev => ({
            ...prev,
            [name]: value
        }))
    };




    const [activeSection, setActiveSection] = useState(null);

    const handleIconClick = (section) => {
        if (section === 'top') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            setActiveSection(section);
        }
    };

    const handleClose = () => {
        setActiveSection(null);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640 && activeSection) {
                setActiveSection(null);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [activeSection]);


    return (
        <>
            <div className="IAFWrap">
                <div className="col-12 col-sm-4 col-md-5 codLogLftBg hide768">
                    {/* <div className="IAFLftLogo">
                        <img src={lywoSymbl} className="" alt="Logo" />
                    </div> */}

                    <div className="manageTxt">
                        <p>This application Process is Managed by <span>LYWO</span></p>
                    </div>
                    <div className="IAF-jc-Box-dsktp mrgnlftJCF">
                        <div className="IAF-input-group">
                            <input
                                type="text"
                                id="codeIn"
                                name="codeInput"
                                placeholder="Enter job code"
                                value={state?.code}
                                disabled
                            />
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <img src={VerifiedUser} className="sucsIcon" alt="Success Icon" />
                            </div>
                        </div>
                    </div>

                    <div className="hgtAcBox-IAF">
                        {/* <h4>About Company</h4> */}
                        <div className="company-info-IAF">
                            <div className="companyLogoWrap">
                                <img src={BASE_URL + state?.companyLogo} className="companyLogo" alt="Logo"
                                    onError={(e) => e.target.src = LYWOLogoSmall} />
                            </div>

                        </div>
                        <p className="">{state?.companyname}</p>
                        <div className="hgtAcContent-IAF">
                            {
                                <p>{state?.aboutCompany}</p>
                            }
                        </div>
                    </div>
                    <div className="hrImgWrap">
                        <img src={FemaleHr} className="hrImg" alt="Logo" />
                    </div>
                </div>

                <div className="col-12 col-sm-8 col-md-7 fullWdth768">

                    {/* <div className="IAFmobLogo">
                        <img src={lywoSymbl} className="" alt="Logo" />
                    </div> */}
                    <div className="IAFSpc">
                        <div className="JAPformSpc dFlx">
                            <div className="IAFBox">
                                <div className="IAF-jc-Box IAF-jc-mobOnly">
                                    <div className="IAF-input-group">
                                        <input
                                            type="text"
                                            id="codeIn"
                                            name="codeInput"
                                            placeholder="Enter job code"
                                            value="JOB-2024-001"
                                            disabled
                                        />
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <img src={VerifiedUser} className="sucsIcon" alt="Success Icon" />
                                        </div>
                                    </div>
                                </div>
                                <div className="pdgIAFBox">
                                    <div className="JAFhdGWrap">
                                        <h3>Internal Assessment Form</h3>
                                        <p>Please fill your details to start assessment</p>
                                    </div>

                                    <div className="logInCodeWrap IAFwidtH">
                                        <div className="">
                                            <div className="mb-3">
                                                <label htmlFor="Name">Name <span className="astrics">*</span></label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        id="Name"
                                                        name="name"
                                                        placeholder="Type here"
                                                        value={details?.name}
                                                        // disabled={state?.isEditDetails}
                                                        onChange={handleInputChange}
                                                        className={`
                            boxShowDow
                           ${errors?.name && !details?.name.trim() ? 'input-error-jaf' : ''}`}
                                                    />
                                                    {errors.name && !details?.name.trim() && <span className="error-text-jaf">{errors.name}</span>}
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="Email">Email <span className="astrics">*</span></label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        id="Email"
                                                        name="email"
                                                        placeholder="Type here"
                                                        value={details.email}
                                                        onBlur={handleValidedEmailMsg}
                                                        // disabled={state?.isEditDetails}
                                                        onChange={handleInputChange}
                                                        className={`
                            boxShowDow
                           ${errors.email && !isValidEmail(details.email) ? 'input-error-jaf' : ''}`}
                                                    />
                                                    {errors.email && !isValidEmail(details.email) && <span className="error-text-jaf">{errors.email}</span>}                                           </div>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="Phone">Phone <span className="astrics">*</span></label>
                                                <div>
                                                    {/* <PhoneNumber /> */}
                                                    <div className=" d-flex gap-1">
                                                        <div className="input-group" style={{ marginTop: '-3px', width: '100px' }}>
                                                            <CustomSelect

                                                                options={countryCodes}
                                                                labelKey={'dial_code'}
                                                                valKey={"dial_code"}
                                                                value={details.countryCode}
                                                                handleChange={(e) => {
                                                                    handleInputChange({ target: { name: 'countryCode', value: e } });
                                                                }}
                                                                isClearaAble={false}
                                                                hideIcon={true}
                                                            />
                                                        </div>
                                                        <div className="input-group">
                                                            <input
                                                                type="tel"
                                                                style={{ height: '52px' }}
                                                                id="no"
                                                                // disabled={state.isEditDetails}
                                                                name="no"
                                                                placeholder="Phone"
                                                                value={details.no}
                                                                // onChange={handleInputChange}
                                                                onBlur={handleUserCreateOnNo}
                                                                onChange={(e) => {
                                                                    // Allow only digits
                                                                    const cleanedValue = e.target.value.replace(/\D/g, '');
                                                                    handleInputChange({ target: { name: 'no', value: cleanedValue?.trim() } });
                                                                }}
                                                                className={errors.no && (details.no?.trim().length < 9 || details.no?.trim().length > 14) ? 'input-error-jaf' : ''}
                                                            />
                                                            {errors.no && (details.no?.trim().length < 9 || details.no?.trim().length > 14) && <span className="error-text-jaf">{errors.no}</span>}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-3" name='currentDepartment'>
                                                <label htmlFor="CurrentJobTitleInput">Current Job Title{details?.experinces != "0" && <span className="astrics">*</span>}</label>
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        id="CurrentJobTitleInput"
                                                        name="currentJobTittle"
                                                        placeholder="Type here"
                                                        value={details.currentJobTittle}
                                                        onChange={handleInputChange}
                                                        className={`
                            boxShowDow
                           ${errors.currentJobTitle && !details.currentJobTittle.trim() ? 'input-error-jaf' : ''}`}
                                                    />
                                                    {errors.currentJobTitle && !details.currentJobTittle.trim() && <span className="error-text-jaf">{errors.currentJobTitle}</span>}
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="CurrentDepartmentInput">Department {details?.experinces != "0" && <span className="astrics">*</span>}</label>
                                                <div className="input-group">
                                                    <CustomSelect
                                                        placeholder="Type here to search"
                                                        options={departments}
                                                        labelKey={'name'}
                                                        valKey={"id"}
                                                        value={details.departmentId}
                                                        errorMsg={!details.departmentId && errors.currentDepartment}
                                                        handleChange={(e) => {
                                                            handleInputChange({ target: { name: 'departmentId', value: e } });
                                                        }}
                                                        isClearaAble={false}
                                                    />


                                                </div>
                                                <p className="mt-1 mb-0" style={{ fontSize: "11px" }}>
                                                    Select the closest match.
                                                </p>
                                                {errors.currentDepartment && !details.departmentId && <span className="error-text-jaf">{errors.currentDepartment}</span>}
                                            </div>
                                            {/* <div className="mb-3" name='educationLevel'>
                                                <label htmlFor="EducationLevelInput">Education Level <span className="astrics">*</span></label>
                                                <div className="input-group">
                                                    <CustomSelect
                                                        placeholder="Type here to search"
                                                        options={educationLevel}
                                                        labelKey={'label'}
                                                        valKey={"label"}
                                                        value={details.educationlevel}
                                                        errorMsg={!details.educationlevel && errors.educationLevel}
                                                        handleChange={(e) => {
                                                            handleInputChange({ target: { name: 'educationlevel', value: e } });
                                                        }}
                                                        isClearaAble={false}
                                                    />
                                                </div>
                                                {errors.educationLevel && !details?.educationlevel && <span className="error-text-jaf">{errors.educationLevel}</span>}
                                            </div> */}
                                            {/* <div className="mb-3" name="fieldOfEducation">
                                                <label htmlFor="FieldOfEducationInput">Field of Education <span className="astrics">*</span></label>
                                                <div className="input-group">
                                                    <CustomSelect
                                                        placeholder="Type here to search"
                                                        options={specialization}
                                                        labelKey={'specializationName'}
                                                        valKey={"specializationId"}
                                                        value={details.fieldOfEducation}
                                                        errorMsg={!details.fieldOfEducation && errors.fieldOfEducation}
                                                        handleChange={(e) => {
                                                            handleInputChange({ target: { name: 'fieldOfEducation', value: e } });
                                                        }}
                                                        isClearaAble={false}
                                                    />
                                                </div>
                                                {errors.fieldOfEducation && !details.fieldOfEducation && <span className="error-text-jaf">{errors.fieldOfEducation}</span>}
                                            </div> */}
                                            <div className="mb-3">
                                                <label htmlFor="ExperienceInput">Experience <span className="astrics">*</span></label>
                                                <div className="input-group">
                                                    <CustomSelect
                                                        placeholder="Type here to search"
                                                        options={expOptions}
                                                        labelKey={"label"}
                                                        valKey={"value"}
                                                        value={details.experinces}
                                                        errorMsg={
                                                            !details.experinces && errors.experinces
                                                        }
                                                        handleChange={(e) => {
                                                            handleInputChange({
                                                                target: { name: "experinces", value: e },
                                                            });
                                                        }}
                                                        isClearaAble={false}
                                                    />

                                                </div>
                                                {errors.experinces && !details.experinces && <span className="error-text-jaf">{errors.experinces}</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="btnAreaWrap">

                                        <CustomButton
                                            title={state?.isEditDetails && !isRedirect ? 'Save & Go back' : 'Proceed'}
                                            handleClick={handleProceed}
                                            isIcon={true}
                                            src={arrowRight}
                                            isLoading={isApiCalled}
                                        />


                                    </div>
                                    {
                                        isNotFilledData &&

                                        <div className="d-flex justify-content-center mt-2">
                                            <p className="text-danger">Please fill all mandatory (*) fields to Proceed</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {activeSection && <div className="modalOverlayBg" onClick={handleClose}></div>}
                <div className={`slideModal ${activeSection ? 'open' : ''}`}>
                    <div className="modalContentWrap">

                        {activeSection === 'aboutCompany' && (
                            <>
                                <div className="modalAC">
                                    <div className="ModalcloseBtn" >
                                        <h4 className="mb-0">About Company</h4>
                                        <img src={closeIcon} className="mobIcon" alt="" onClick={handleClose} />
                                    </div>
                                    <div className="company-info">
                                        <div className="companyLogoWrap">
                                            <img src={BASE_URL + state?.companyLogo} className="companyLogo" alt="Logo"
                                                onError={(e) => e.target.src = LYWOLogoSmall} />
                                        </div>
                                        <p className="com-infop">{state?.companyname}</p>
                                    </div>
                                    <div className="modalAC-contnt">
                                        {
                                            state?.aboutCompany
                                        }
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="mobile-icons">
                    <div className="mobile-icon-txt" onClick={() => handleIconClick('aboutCompany')}>
                        <img src={aboutCompanyIcon} className="mobIcon" alt="About Company" />
                        <p>About Company</p>
                    </div>
                    <div className="mobile-icon-txt" onClick={() => handleIconClick('top')}>
                        <img src={backtoTopIcon} className="mobIcon" alt="Back to Top" />
                        <p>Back to Top</p>
                    </div>
                </div>
            </div>
        </>

    );
};

export default InternalAssessmentForm;